import { Box, CssBaseline, Link, ThemeProvider } from '@mui/material';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Providers } from './providers';
import { medicareAiTheme } from '@coverright/ui/themes';
import { AppBar } from './ui/app-bar';

export function App() {
  return (
    <ThemeProvider theme={medicareAiTheme}>
      <Providers>
        <CssBaseline />
        <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column' }}>
          <AppBar />
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', pt: '57px' }}>
            <Outlet />
          </Box>
          <Box p={2}>
            <Link target={'_blank'} href={'https://coverright.com/privacy-policy/'} fontWeight={500} variant={'body2'}>
              Privacy policy
            </Link>
          </Box>
        </Box>
      </Providers>
    </ThemeProvider>
  );
}

export default App;
